import * as snapshotHelpers from 'bundles/backoffice/contacts/snapshots';

const primaryRolesByDealType = {
  buyer_rep: ['buyer', 'buyer_contact', 'client'],
  tenant_rep: ['tenant', 'tenant_contact', 'client'],
};

export function getPrimaryContact(deal) {
  const roles = primaryRolesByDealType[deal.dealType] || [];
  const primaryRole = deal.contactRoles.find(contactRole => roles.includes(contactRole.role));
  return primaryRole?.contact;
}

export function findLocalContact(contact, deal) {
  return snapshotHelpers.findLocalContact(contact, getSnapshotParentsByType(deal));
}

export function replaceContact(contact, deal) {
  return snapshotHelpers.replaceContact(contact, contact.idChanges, getSnapshotParentsByType(deal));
}

function getSnapshotParentsByType(deal) {
  return {
    commissions: deal.commissions,
    contactRoles: deal.contactRoles,
  };
}
